<template>
  <div class="angel-fund-project-list">
    <div class="manage-table">
      <avue-crud
        :option="tableConfig"
        :data="tableData"
        ref="crud"
        :page.sync="page"
        :search.sync="searchForm"
        :summary-method="summaryMethod"
        @search-reset="searchResets"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @refresh-change="queryTableData"
        @selection-change="selectionChange"
        :class="[{ avue_no_left: !isEdit }]"
        :header-cell-class-name="headerClassName"
      >
        <template slot="menuLeft" v-if="isEdit">
          <el-button
            size="small"
            type="primary"

            icon="el-icon-plus"
            @click="handleAdd"
          >
            新建
          </el-button>
          <el-button
            type="primary"
            plain
            size="small"

            @click.stop="handleEdit"
          >
            编辑
          </el-button>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain

            @click.stop="handleDelete"
          >
            删除
          </el-button>
        </template>
        <template slot="companyName" slot-scope="{ row }">
          <div class="project-name" @click="showDetail(row)">
            {{ row.companyName }}
          </div>
        </template>
      </avue-crud>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :title="
        dialogType == 1 ? '新建项目' : dialogType == 2 ? '编辑项目' : '项目详情'
      "
      :visible.sync="dialogShow"
      width="70%"
    >
      <div class="add-content" v-if="dialogType != 3">
        <div class="add-person-form-container">
          <avue-form
            ref="addProjectInfoForm"
            v-model="formData"
            :option="addProjectFormConfig"
          >
          </avue-form>
        </div>

        <div class="project-tip">
          <div class="tip-line">填写说明：</div>
          <div class="tip-line">
            1.报告期内如有诉讼、仲裁或行政处罚等重大时间发生，请说明对基金所投资项目的影响。
          </div>
          <div class="tip-line">2.报告期内股东会、董事会召开情况。</div>
          <div class="tip-line">3.其他</div>
        </div>
      </div>
      <CommonDetail v-else :configArray="formConfig" :initValue="formData" />
      <span slot="footer" class="dialog-footer" v-if="dialogType != 3">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  fundProjectListConfig,
  addProjectFormConfig,
  paymentInfoConfig,
} from "./config.js";
import {
  getSubFundProjectList,
  getClientProjectList,
  getClientProjectListTotal,
  submitClientProject,
  deleteClientProject,
} from "@/api/fund/subfunds";
import CommonDetail from "@/components/commonDetail/fundCommonDetail";
import { mapGetters } from "vuex";
import util from "@/mixins/util";
export default {
  name: "FundProjectListComponent",
  mixins: [util],
  data() {
    return {
      tableData: [],
      dialogType: 1,
      formData: {},
      dialogShow: false,
      selectionList: [],
      tableConfig: fundProjectListConfig(this.getMoney),
      addProjectFormConfig: addProjectFormConfig(),
      formConfig: paymentInfoConfig(this.getMoney),
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      totalData:[]
    };
  },
  components: {
    CommonDetail,
  },
  watch: {
    isEdit: {
      handler(newValue, oldValue) {
        if (newValue == true) {
          this.tableConfig.selection = true;
          this.queryTableData();
        }
      },
      immediate: true,
    },
  },
  props: {
    fundId: {
      type: String,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
    bizType: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  mounted() {},
  methods: {
    headerClassName(tab) {
      return "avue_bgc";
    },
    summaryMethod({ columns, data }) {
      const self = this;
      const sums = [];

      let arrays = [
        "investAmount",
        "surplusInvestPrincipal",
        "investIncome",
      ];
      if (columns.length > 0) {
        columns.forEach((column, index) => {
          if (arrays.includes(column.property)) {
            // 赋值totalData
            sums[index] = self.getMoney(
              Math.round(Number(self.totalData[column.property]) * 100) / 100
            );
          } else {
            sums[index] = "";
          }
        });
      }
      sums[1] = "合计:";
      return sums;
    },
    selectionChange(data) {
      this.selectionList = data;
    },

    searchChange(query, done) {
      this.searchForm = query;
      this.queryTableData();
      done();
    },

    async queryTableData() {
      let params = {
        basicInfoId: this.fundId,
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
        bizType: this.bizType,
      };
      let res = {};

      if (
        this.isEdit ||
        (this.$route.query && this.$route.query.audit == "true")
      ) {
        res = await getClientProjectList(params);
      } else {
        res = await getSubFundProjectList(params);
      }
      
      let totalData = await getClientProjectListTotal(params)
      this.totalData = totalData.data.data     

      if (res.data.code == 200) {
        this.tableData = res.data.data.records;
        this.page.total = res.data.data.total;
      } else {
        this.$message.error(res.data.msg);
      }
    },

    async showDetail(row) {
      this.dialogType = 3;
      this.dialogShow = true;
      // 设置数据
      let setData = row;
      setData.industryStr = await this.queryDict(
        setData.industry,
        "/api/blade-system/dict-biz/dictionary?code=industry_type_all"
      );
      this.formData = row;
    },

    handleAdd() {
      this.dialogType = 1;
      this.dialogShow = true;
      this.formData = {
        id: "",
        companyName: "",
        country: "",
        industry: "",
        investDate: "",
        investAmount: "",
        stockRatio: "",
        investRound: "",
        stockValuation: "",
        investIncome: "",
        surplusInvestPrincipal: "",
        otherStock: "",
        director: "",
        companyProfile: "",
        industryProfile: "",
        financialCondition: "",
        investPostCondition: "",
        quitPlan: "",
        risk: "",
        otherMatter: "",
      };
      if (this.$refs.addProjectInfoForm)
        this.$refs.addProjectInfoForm.clearValidte();
    },

    handleEdit() {
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行编辑");
      } else if (this.selectionList.length == 1) {
        this.dialogType = 2;
        this.dialogShow = true;
        this.formData = this.selectionList[0];
      } else {
        this.$message.error("请选择一条数据进行编辑");
      }
    },

    handleDelete() {
      let self = this;
      this.$confirm("确定删除选择的数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let ids = self.selectionList.map((item) => {
            return item.id;
          });
          let res = await deleteClientProject({ ids: ids.join(",") });
          if (res.data.code == 200) {
            self.$message.success("删除成功");
            // 刷新列表
            self.queryTableData();
          }
        })
        .catch(() => {
          self.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    submitForm() {
      let self = this;
      this.$refs.addProjectInfoForm.validate(async (valid, done) => {
        done();
        if (valid) {
          let params = {
            basicInfoId: this.fundId,
            ...self.formData,
            bizType: this.bizType,
          };
          let res = await submitClientProject(params);
          console.info(res, "submitClientProject");
          if (res.data.code == 200) {
            self.dialogShow = false;
            self.$message.success(self.formData.id ? "修改成功" : "新建成功");
            self.queryTableData();
          }
        } else {
          self.$message.warning("请补全表单后提交");
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.angel-fund-project-list {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .radiobut {
    margin: 25px 0;
  }
  .manage-table {
    background: #ffff;
    // padding: 25px;
  }
  .project-name {
    // overflow: hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    color: #409eff;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
  /deep/.el-badge__content {
    line-height: 17px;
    padding: 0 5px;
    z-index: 29;
  }
  .el-table__fixed,
  .el-table__fixed-right {
    height: calc(100% - 0px) !important;
  }
  /deep/.el-table {
    display: flex !important;
    flex-direction: column !important;
  }
  //  order默认值为0，只需将表体order置为1即可移到最后，这样合计行就上移到表体上方
  /deep/.el-table__body-wrapper {
    order: 1 !important;
  }

  /deep/.el-table__fixed-footer-wrapper {
    top: 40px !important;
    z-index: 0;
  }
  /deep/.el-table__fixed-body-wrapper {
    top: 80px !important;
  }
}
/deep/ .right_radio .el-radio-button__inner {
  border-left: 0;
  border-radius: 0 4px 4px 0;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
/deep/ .center_radio .el-radio-button__inner {
  border-left: 0;
  border-radius: 0;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.fund-right-content {
  .right-btn {
    margin-left: 0 !important;
    margin-bottom: 10px;
    width: 100%;
    color: black;
    font-size: 14px;
  }
  .right-btn:hover {
    color: #64b0ff;
  }
}
.plus-right {
  color: #f56c6c !important;
  font-weight: 600;
  font-size: 16px;
}
/deep/.ant-popover-placement-right {
  width: 170px !important;
}
/deep/ .el-table .cell,
/deep/ .el-table th > .cell {
  padding-left: 0px;
  padding-right: 0px;
}
/deep/ .el-table .cell {
  font-size: 14px;
}
// /deep/ .el-table__fixed-footer-wrapper{
//     display: none !important;
// }

/deep/.el-table__footer-wrapper,
/deep/.el-table__fixed-footer-wrapper {
  .cell {
    color: red;
  }
}
/deep/.avue_bgc {
  background: #f6faff !important;
  font-weight: 400 !important;
}

// /deep/.el-table td {
//   padding:12px 0 !important
// }
/deep/ .el-table {
  border-color: #e0eeff;
}
/deep/.avue-crud {
  width: 100%;
}
/deep/ .avue_no_left {
  .avue-crud__menu {
    display: none;
  }
}
</style>
<style lang="scss">
.ant-popover-placement-right {
  width: 170px !important;
}
</style>

